import classNames from "classnames";
import React from "react";
import { SWATCHES } from "./../../../../color-picker/common/data-hooks";
import { AddColorButton } from "../add-color-button";
import { SingleColorSwatch } from "../single-color-swatch";
import classes from "./new-color-swatches-scss";
const NewColorSwatches = ({
  colors,
  selectedColor,
  onAddClick,
  onColorSelected,
  onColorPreviewStart,
  onColorPreviewEnd,
  dataHook,
  setAddButtonRef
}) => {
  return /* @__PURE__ */ React.createElement("div", { "data-hook": dataHook }, /* @__PURE__ */ React.createElement("div", { className: classNames(classes.container), "data-hook": SWATCHES }, colors.map((color) => /* @__PURE__ */ React.createElement(
    SingleColorSwatch,
    {
      key: color,
      fill: color,
      selectedColor,
      onClick: onColorSelected,
      onMouseEnter: onColorPreviewStart,
      onMouseLeave: onColorPreviewEnd
    }
  )), !!onAddClick && /* @__PURE__ */ React.createElement(AddColorButton, { onAddClick, setRef: setAddButtonRef })));
};
export {
  NewColorSwatches
};
//# sourceMappingURL=new-color-swatches.js.map
